// Import model
import { ExpressionFieldOptions } from '../models/ExpressionFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ExpressionFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class ExpressionFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a ExpressionFieldOptions instance
   */
  static deserialize(json: string): ExpressionFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ExpressionFieldOptions instance
   */
  static fromObject(obj: any): ExpressionFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ExpressionFieldOptions');
    }


    const instance: ExpressionFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      cb5C8Aa5: obj['_cb5c8aa5'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ExpressionFieldOptions instances
   */
  static deserializeArray(json: string): ExpressionFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ExpressionFieldOptions instance to a JSON string
   */
  static serialize(instance: ExpressionFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ExpressionFieldOptions instance to a plain object
   */
  static toObject(instance: ExpressionFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      '_cb5c8aa5': instance.cb5C8Aa5,
    };
  }

  /**
   * Serializes an array of ExpressionFieldOptions instances to a JSON string
   */
  static serializeArray(instances: ExpressionFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
